import { Component } from '@angular/core';
import { Helper } from './Helper';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { CommonApisService } from './common-apis.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})
export class AppComponent {
  title = 'my-app';
   

  constructor(
    public Helper:Helper,
    public router:Router,
    public ca:CommonApisService
  ){
     
   Helper.getDropdowns();
   Helper.getNotifications();
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
          this.Helper.showLoader(true) 
      } else if (event instanceof RouteConfigLoadEnd) {
        this.Helper.showLoader(false) 
      }
  });
 

    
   
  }
  onActivate(event) {
    window.scroll(0,0);
    
  }
}
